import React from 'react';
import styles from './LegalPage.module.css';

export default function PrywatnoscPage() {
  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <p className={styles.eyebrow}>Dokument prawny</p>
        <h1>Polityka prywatności</h1>
        <p className={styles.updated}>Obowiązuje od: 1 stycznia 2025 r.</p>

        <section>
          <h2>1. Administrator danych osobowych</h2>
          <p>Administratorem Twoich danych osobowych jest osoba fizyczna prowadząca niekomercyjny serwis Nieruchomy.pl (dalej: „Administrator").</p>
          <p>Kontakt w sprawach danych osobowych: <strong>rodo@nieruchomy.pl</strong></p>
          <p>Serwis jest prowadzony nieodpłatnie, bez działalności gospodarczej, wyłącznie jako projekt hobbystyczny/społeczny. Nie pobieramy żadnych opłat od użytkowników.</p>
        </section>

        <section>
          <h2>2. Jakie dane zbieramy i po co</h2>
          <p>Zbieramy tylko dane niezbędne do działania Serwisu:</p>
          <ul>
            <li><strong>Dane rejestracyjne:</strong> imię i nazwisko, adres e-mail, numer telefonu (opcjonalnie). Hasło przechowywane jest wyłącznie w postaci zaszyfrowanej (bcrypt) — nie znamy Twojego hasła.</li>
            <li><strong>Dane ogłoszeń:</strong> tytuł, opis, cena, lokalizacja, zdjęcia nieruchomości dodane przez Ciebie.</li>
            <li><strong>Dane techniczne:</strong> adres IP i czas wizyty zapisywane automatycznie w logach serwera przez maksymalnie 90 dni.</li>
          </ul>
          <p>Nie profilujemy użytkowników. Nie sprzedajemy danych. Nie wyświetlamy reklam.</p>
        </section>

        <section>
          <h2>3. Podstawa prawna przetwarzania</h2>
          <ul>
            <li><strong>Wykonanie umowy (art. 6 ust. 1 lit. b RODO)</strong> — prowadzenie konta, obsługa ogłoszeń, weryfikacja e-mail, reset hasła.</li>
            <li><strong>Uzasadniony interes Administratora (art. 6 ust. 1 lit. f RODO)</strong> — bezpieczeństwo Serwisu, logi serwera, zapobieganie nadużyciom.</li>
          </ul>
        </section>

        <section>
          <h2>4. Jak długo przechowujemy dane</h2>
          <ul>
            <li>Dane konta — przez czas aktywności konta. Po usunięciu konta dane są kasowane w ciągu 30 dni.</li>
            <li>Dane ogłoszeń — przez czas ich publikacji oraz 90 dni po usunięciu.</li>
            <li>Logi serwera — maksymalnie 90 dni.</li>
            <li>Kody weryfikacyjne i resetowania hasła — 15 minut od wygenerowania.</li>
          </ul>
        </section>

        <section>
          <h2>5. Komu udostępniamy dane</h2>
          <p>Dane przekazywane są wyłącznie podmiotom niezbędnym do działania Serwisu:</p>
          <ul>
            <li><strong>Resend.com</strong> — wysyłka e-maili (weryfikacja konta, reset hasła). Dane przetwarzane zgodnie z ich polityką prywatności dostępną na resend.com.</li>
            <li><strong>Hetzner Online GmbH</strong> (lub inny dostawca hostingu) — przechowywanie danych na serwerze.</li>
          </ul>
          <p>Nie udostępniamy danych reklamodawcom, partnerom marketingowym ani innym podmiotom trzecim.</p>
        </section>

        <section>
          <h2>6. Analityka — Plausible</h2>
          <p>Korzystamy z <strong>Plausible Analytics</strong> — narzędzia do statystyk odwiedzin które:</p>
          <ul>
            <li>nie używa cookies,</li>
            <li>nie zbiera danych osobowych ani adresów IP,</li>
            <li>nie śledzi użytkowników między stronami,</li>
            <li>jest w pełni zgodne z RODO bez konieczności uzyskiwania zgody.</li>
          </ul>
          <p>Więcej informacji: <a href="https://plausible.io/data-policy" target="_blank" rel="noreferrer" style={{color:'var(--gold)'}}>plausible.io/data-policy</a></p>
        </section>

        <section>
          <h2>7. Twoje prawa (RODO)</h2>
          <p>Przysługują Ci następujące prawa:</p>
          <ul>
            <li><strong>Dostęp do danych</strong> — możesz zażądać kopii swoich danych.</li>
            <li><strong>Sprostowanie</strong> — możesz poprawić nieprawidłowe dane.</li>
            <li><strong>Usunięcie</strong> — możesz żądać usunięcia konta i wszystkich danych.</li>
            <li><strong>Ograniczenie przetwarzania</strong> — możesz żądać wstrzymania przetwarzania.</li>
            <li><strong>Przenoszenie danych</strong> — możesz otrzymać swoje dane w formacie JSON.</li>
            <li><strong>Sprzeciw</strong> — możesz sprzeciwić się przetwarzaniu w oparciu o uzasadniony interes.</li>
          </ul>
          <p>Aby skorzystać z praw, napisz na: <strong>rodo@nieruchomy.pl</strong>. Odpowiem w terminie do 30 dni.</p>
          <p>Masz też prawo złożyć skargę do Prezesa Urzędu Ochrony Danych Osobowych (uodo.gov.pl).</p>
        </section>

        <section>
          <h2>8. Pliki cookie i localStorage</h2>
          <p>Serwis nie używa plików cookies do celów reklamowych ani śledzenia.</p>
          <p>Używamy <strong>localStorage</strong> przeglądarki wyłącznie do:</p>
          <ul>
            <li>przechowywania tokenu logowania (JWT) — niezbędne do działania konta,</li>
            <li>zapamiętania że zapoznałeś/aś się z informacją o cookies.</li>
          </ul>
          <p>Dane te są przechowywane wyłącznie na Twoim urządzeniu i możesz je usunąć w ustawieniach przeglądarki.</p>
        </section>

        <section>
          <h2>9. Bezpieczeństwo</h2>
          <p>Stosujemy następujące środki techniczne ochrony danych:</p>
          <ul>
            <li>Hasła hashowane algorytmem bcrypt — nie mamy dostępu do Twojego hasła</li>
            <li>Połączenia szyfrowane protokołem HTTPS/TLS</li>
            <li>Tokeny JWT z czasem wygaśnięcia (7 dni)</li>
            <li>Ograniczenie liczby prób logowania (ochrona przed brute-force)</li>
            <li>Walidacja i sanityzacja danych wejściowych</li>
          </ul>
        </section>

        <section>
          <h2>10. Charakter niekomercyjny Serwisu</h2>
          <p>Serwis Nieruchomy.pl jest prowadzony przez osobę prywatną jako projekt niekomercyjny. Nie prowadzimy działalności gospodarczej, nie pobieramy opłat, nie wyświetlamy reklam i nie czerpiemy dochodów z działalności Serwisu. W związku z tym niektóre wymogi typowe dla serwisów komercyjnych (np. obowiązki przedsiębiorcy wobec konsumentów) nie mają w tym przypadku zastosowania.</p>
        </section>

        <section>
          <h2>11. Zmiany polityki prywatności</h2>
          <p>O istotnych zmianach poinformujemy zarejestrowanych użytkowników drogą e-mailową co najmniej 14 dni przed ich wejściem w życie. Aktualna wersja dostępna jest zawsze pod adresem nieruchomy.pl/prywatnosc.</p>
        </section>
      </div>
    </div>
  );
}
